import "./footer.scss";

function Footer() {
  return (
    <footer className="footer">
      <ul className="footer__list">
        <li>
          <a href="https://deltalf.github.io/">About</a>{" "}
        </li>
        <li>
          <a href="https://github.com/DeltaLF/online-course">GitHub</a>{" "}
        </li>
        <li>Copyright © 2023</li>
      </ul>
    </footer>
  );
}

export default Footer;
